import React from 'react'
import { absoluteCenter, customStyles } from '../../../styles'
import { MainContainer } from '../../containers'
import { Title } from '../../helpers'
import { CaptionText } from '../../helpers/text/CaptionText'
import { RegularText } from '../../helpers/text/RegularText'
import { SmallText } from '../../helpers/text/SmallText'
import { SubTitle } from '../../helpers/text/SubTitle'
import { ModalHeader } from '../../modals/ModalHeader'
import image from '../../../assets/images/logo.png'
import { CardsContainer } from './CardsContainer'
import { CardItem } from './CardItem'
import { animations } from '../../../utils/animations'
import { useDispatch, useSelector } from 'react-redux'
import { CircularProgress, Grid } from '@mui/material';
import { useEffect } from 'react'
import { getOrderHistory } from '../../../actions/orderActions'
import { useLocalStorage } from '../../../hooks/useLocalStorage'


export const HistoryOrders = () => {
  const { main } = customStyles.colors
  const { fadeTop } = animations
  const [authorization] = useLocalStorage('login-token', null)
  const { orderHistory } = useSelector(state => state.order)
  const dispatch = useDispatch()
  useEffect(() => {
    !orderHistory && dispatch(getOrderHistory(authorization?.token))
  }, [])
  return (
    <MainContainer sx={{ marginBottom: 10,  }}>
      <ModalHeader  backward={false}/>
      <SubTitle text="Historial de pedidos" color={main}/>  
      {/* <CardsContainer /> */}
      

      <Grid container spacing={1} >
      {
        orderHistory === null
        ? <CircularProgress sx={ {...absoluteCenter, left: '45%'} }/>
        : orderHistory.map((item, index) => (
            <CardItem data={item} key={item.id}/>
          ))
        }
      </Grid>
    </MainContainer>
  )
}
